"use client";

import React, { createContext, useState, useContext, useEffect } from "react";

type Theme = "light" | "dark";

type ThemeContextType = {
  theme: Theme;
  toggleTheme: () => void;
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>("light");
  const [isInitialized, setIsInitialized] = useState(false);

  // 🌓 Inicialización: forzar siempre light theme
  useEffect(() => {
    // Forzar siempre light theme
    setTheme("light");
    localStorage.setItem("theme", "light");
    setIsInitialized(true);
  }, []);

  // 🎨 Aplicar el tema al documento (siempre light)
  useEffect(() => {
    if (isInitialized) {
      // Siempre remover dark class
      document.documentElement.classList.remove("dark");
    }
  }, [isInitialized]);

  const toggleTheme = () => {
    // No-op: no permitir cambiar a dark mode
    // El tema siempre será light
  };

  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
